import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnInit, Output, Injector, ChangeDetectionStrategy } from '@angular/core';
import { Admpi83Component } from '../admpi83/admpi83.component';
import { CrudbarComponent, MaterialModule } from 'jk-service';
import { JkBillFormComponent } from 'jk-advcom';

@Component({
  selector: 'app-admpi83-bill',
  standalone: true,
  imports: [CommonModule,
    MaterialModule,
    CrudbarComponent,
    Admpi83Component,
    //Admi10DetailComponent,
  ],
  templateUrl: './admpi83BillPkg.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: [],
})
export class Admpi83BillComponent extends JkBillFormComponent implements OnInit {
  override _programId = ' admpi83'; //###
  override masterPage!: Admpi83Component;

  //override detailPage!:  Admi10DetailComponent;
  constructor() {
    super();

    this.setFormOpt2(); //###
  }

  override ngOnInit() {
    super.ngOnInit();
  }
  override async ngAfterViewInit() {
    super.ngAfterViewInit();
  }
  override doMasterPageReady($event: any) {
    super.doMasterPageReady($event);
  }
  // 以下客製 --------------------------------------------------------


}
